import { useTranslation } from "react-i18next";
import SyIcon from "../../../../../shared/components/sy-icon";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { planetValidationSchema } from "../../../../../shared/components/schema-validation/schema-validation";
import OrbInput from "../../../../../shared/forms/orb-input";
import OrbImageSlider from "../../../../../shared/components/orb-image-slider";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../../../feature/image-slice";
import { getOrbitDetails } from "../../../../../feature/orbit-slice";
import { useMemo, useState } from "react";
import { planetInputProps } from "../planet-screen-interface";
import { planetManageConfig, statusOption } from "../planet-screen-config";
import OrbTextEditor from "../../../../../shared/forms/orb-text-editor";
import SyDropdown from "../../../../../shared/forms/sy-dropdown";
import OrbButton from "../../../../../shared/components/orb-button";
import { useMutation } from "@tanstack/react-query";
import planetService from "../../../services/planet-service";

const PlanetManage = (props: any) => {
  const { close, planetStatus } = props;
  const imageSlice = useSelector(getImageDetails);
  const orbitSlice = useSelector(getOrbitDetails);
  const { t } = useTranslation();
    const [selectedPlanet, setSelectedPlanet] = useState<any>(null);
    const [selectedLand, setSelectedLand] = useState<any>(null);
    const [selectedBulding, setSelectedBulding] = useState<any>(null);
    
  const defaultValues = {
    pro_name: "",
    pro_sub: "",
    pro_address: "",
    pro_status_id: planetStatus[0],
    pro_contact_name: "",
    pro_contact_address: "",
    pro_contact_email: "",
    pro_contact_phone: "",
    orb_id: orbitSlice.selectOrbit,
    pro_desc: "",
  };

  const {
    setValue,
    getValues,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
    resolver: yupResolver(planetValidationSchema),
  });

  const handleStatusLabel = (data: any) => data?.st_name;

  const InputField = useMemo(
    () => (props: planetInputProps) => {
      const { name, type, placeholder, errorMessage, label, fieldType } = props;
      return (
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) =>
            fieldType === "dropDown" ? (
              <>
                <p className="mb-1 text-white mohave main-font">{t(label)}</p>
                <SyDropdown
                  options={planetStatus}
                  placeholder={t(placeholder)}
                  handleChange={onChange}
                  getoptlabel={handleStatusLabel}
                  value={value}
                  clearIcon={true}
                />
              </>
            ) : fieldType === "textEditor" ? (
              <OrbTextEditor placeholder="" value={value} onChange={onChange} />
            ) : (
              <OrbInput
                type={type}
                placeholder={t(placeholder)}
                value={value}
                onChange={onChange}
                errorMessage={t(errorMessage)}
                label={t(label)}
              />
            )
          }
        />
      );
    },
    [control]
  );


  const onSelectPlanet = (data: any) => {
    if (data) {
      const type = {
        id: data.id,
        type: 1,
      };
      setSelectedPlanet(type);
    }
  };

  const onSelectFrame = (data: any) => {
    if (data) {
      const type = {
        id: data.id,
        type: 2,
      };
      setSelectedLand(type);
    }
  };
  const onSelectObject = (data: any) => {
    if (data) {
      const type = {
        id: data.id,
        type: 3,
      };
      setSelectedBulding(type);
    }
  };

  const onSubmit = (Formvalue: any) => {
    const selectedImage: any = [];
    selectedImage.push(selectedPlanet, selectedLand, selectedBulding);
    Formvalue.pro_img = selectedImage;
    Formvalue.pro_status_id = Formvalue.pro_status_id.st_id;
    savePlanet(Formvalue)
  };
  const { mutate: savePlanet,isPending:loading } = useMutation({
    mutationFn: planetService.savePlanet,
    onSuccess(data, variables, context) {
      close();
    },
  });

  return (
    <>
      <div className=" p-3 h-100 sy-scroll-y ">
        <div className="d-flex justify-content-between position-sticky  z-3">
          <p className="font-50 text-white bebas-neue mb-0">
            <span>+</span>
            {t(planetManageConfig.title)}
          </p>
          <SyIcon
            name={"close"}
            iconColor="rgba(255, 255, 255, 0.3)"
            className={" pe-0 pointer"}
            onClick={close}
          />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row mt-2  ">
          <div className="col-lg-9 col-md-6 col-sm-12 ">
           
              <div className="row ">
                {planetManageConfig.planetInputConfig.map((data: any) => {
                  return (
                    <div className={data.style}>
                      <InputField
                        name={data.name}
                        type={data.type}
                        placeholder={data.placeholder}
                        label={data.label}
                        fieldType={data.fieldType}
                        errorMessage={errors?.[data.name]?.message ?? ""}
                      />
                    </div>
                  );
                })}
              </div>
              <p className="font-30 text-white bebas-neue ">
                {t(planetManageConfig.sub_title)}
              </p>
              <div className="row">
                {planetManageConfig.planetContactInputConfig.map(
                  (data: any) => {
                    return (
                      <div className={data.style}>
                        <InputField
                          name={data.name}
                          type={data.type}
                          placeholder={data.placeholder}
                          label={data.label}
                          fieldType={data.fieldType}
                          errorMessage={errors?.[data.name]?.message ?? ""}
                        />
                      </div>
                    );
                  }
                )}
              </div>
             
          
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mt-4">
            <div className="">
              {imageSlice.planet && (
                <OrbImageSlider
                  image={imageSlice.planet}
                  onSelected={onSelectPlanet}
                />
              )}
            </div>

            <div className="mt-5">
              {imageSlice.frame && (
                <OrbImageSlider
                  image={imageSlice.frame}
                  onSelected={onSelectFrame}
                />
              )}
            </div>
            <div className="mt-5">
              {imageSlice.object && (
                <OrbImageSlider
                  image={imageSlice.object}
                  onSelected={onSelectObject}
                />
              )}
            </div>
          </div>
          <div className="col-12">
          <div className="mt-4">
                <OrbButton
                  type={"submit"}
                  className={" mohave "}
                  size={""}
                  iconName={planetManageConfig.btnConfig.icon}
                  label={t(planetManageConfig.btnConfig.label)}
                  loading={loading}
                />
              </div>
          </div>
        </div>
        </form>
      </div>
    </>
  );
};

export default PlanetManage;
